import { memoize } from 'proxy-memoize';
import mergeWith from 'lodash.mergewith';
var EMPTY_OBJECT = Object.freeze({});
var EMPTY_MAP = new Map();
export var getApi = store => store.api;

// User
export var getUser = store => store.user;
export var getUserName = store => getUser(store).name;
export var getUserGroups = store => getUser(store).groups;

// Storage
export var getStorage = store => store.storage;
export var getCommandHistoryStorage = store => getStorage(store).commandHistoryStorage;
export var getFileStorage = store => getStorage(store).fileStorage;
export var getWorkspaceStorage = store => getStorage(store).workspaceStorage;
export var getDefaultWorkspaceSettings = store => store.defaultWorkspaceSettings;

// Workspace
export var getWorkspace = store => {
  var workspace = store.workspace;
  return workspace;
};

// Settings
export var getSettings = memoize(store => {
  var _getWorkspace$data$se, _getWorkspace;
  var customizedSettings = (_getWorkspace$data$se = (_getWorkspace = getWorkspace(store)) === null || _getWorkspace === void 0 ? void 0 : _getWorkspace.data.settings) !== null && _getWorkspace$data$se !== void 0 ? _getWorkspace$data$se : {};
  var defaultSettings = getDefaultWorkspaceSettings(store);

  // Deep merge settings but replace arrays instead of merging them
  var newSettings = mergeWith({}, defaultSettings, customizedSettings, (objValue, srcValue) => {
    if (Array.isArray(objValue) && Array.isArray(srcValue)) {
      return srcValue;
    }
    return undefined;
  });
  return newSettings;
});
export var getDefaultSettings = store => store.defaultWorkspaceSettings;
export var getDefaultDateTimeFormat = store => getSettings(store).defaultDateTimeFormat;
export var getDefaultDecimalFormatOptions = store => {
  var _getSettings$defaultD;
  return (_getSettings$defaultD = getSettings(store).defaultDecimalFormatOptions) !== null && _getSettings$defaultD !== void 0 ? _getSettings$defaultD : EMPTY_OBJECT;
};
export var getDefaultIntegerFormatOptions = store => {
  var _getSettings$defaultI;
  return (_getSettings$defaultI = getSettings(store).defaultIntegerFormatOptions) !== null && _getSettings$defaultI !== void 0 ? _getSettings$defaultI : EMPTY_OBJECT;
};
export var getFormatter = store => {
  var _getSettings$formatte;
  return (_getSettings$formatte = getSettings(store).formatter) !== null && _getSettings$formatte !== void 0 ? _getSettings$formatte : [];
};
export var getTimeZone = store => getSettings(store).timeZone;
export var getShowTimeZone = store => getSettings(store).showTimeZone;
export var getShowTSeparator = store => getSettings(store).showTSeparator;
export var getTruncateNumbersWithPound = store => getSettings(store).truncateNumbersWithPound;
export var getShowEmptyStrings = store => getSettings(store).showEmptyStrings;
export var getShowNullStrings = store => getSettings(store).showNullStrings;
export var getShowExtraGroupColumn = store => getSettings(store).showExtraGroupColumn;
export var getDisableMoveConfirmation = store => getSettings(store).disableMoveConfirmation === true;
export var getShortcutOverrides = store => getSettings(store).shortcutOverrides;
export var getWebGL = store => getSettings(store).webgl;
export var getWebGLEditable = store => getSettings(store).webglEditable;
export var getNotebookSettings = store => {
  var _getSettings$notebook;
  return (_getSettings$notebook = getSettings(store).notebookSettings) !== null && _getSettings$notebook !== void 0 ? _getSettings$notebook : EMPTY_OBJECT;
};
export var getActiveTool = store => store.activeTool;

/**
 * @deprecated Use `usePlugins` hook instead or `PluginsContext` directly
 * @param store Redux store
 * @returns Plugins map
 */
export var getPlugins = store => {
  var _store$plugins;
  return (_store$plugins = store.plugins) !== null && _store$plugins !== void 0 ? _store$plugins : EMPTY_MAP;
};
//# sourceMappingURL=selectors.js.map